import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../../../../../config';
const EditSecondRefinancePage = () => {
  const fileInputRef = useRef(null);
  const { id } = useParams();
  console.log('EditLoanPage', id);
  const [bankList, setBankList] = useState([]);
  const [PIdocument, setPIdocument] = useState([]);
  const [LCdocument, setLCdocument] = useState([]);
  const [AcceptanceCopy, setAcceptanceCopy] = useState([]);
  const [formData, setFormData] = useState({
    UPAS_bank_name: '',
    UPAS_maturity_date: '',
    bank_name: '',
    maturity_date: '',
    PI_document: '',
    LC_document: '',
    Acceptance_copy: '',
  });
  const [isFormVisible, setIsFormVisible] = useState(true);
  const navigate = useNavigate();

  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };
  // Modify handleFileChange to update only the specified document
  const handleFileChange = (e, documentType) => {
    setFormData({
      ...formData,
      [documentType]: e.target.files[0], // Update only the specified document field
    });
  };

  const handleCloseApplyLoan = () => {
    setIsFormVisible(false);
    navigate('/dashboard');
  };

  // Fetch second refinance for editing
  useEffect(() => {
    const baseUrl = `${API_BASE_URL}`; // Make sure to declare it here
    const fetchLoanDetails = async () => {
      try {
        const response = await axios.get(
          // `https://finwise-backend.vercel.app/account/edit-apply-loan/${id}/`,
          // `https://finwiseback.finwise.com.bd/account/edit-apply-loan/${id}/`,
          `${API_BASE_URL}/account/edit-second-refinance-loan/${id}/`,
          // `http://127.0.0.1:8000/account/user-first-refinance-loan/${id}/`,
          {
            headers: {
              Cookie:
                'csrftoken=UUqMP9JcdAzD3XXvbxR1JbI6L0Ql1D36; sessionid=7aa2h3dgciv3gdh0zw5ubcbd2vi22psf',
            },
            withCredentials: true,
          }
        );
        console.log("second refinance edit data:", response.data)
        setFormData({
          UPAS_bank_name: response.data.UPAS_bank_name,
          UPAS_maturity_date: response.data.UPAS_maturity_date,
          bank_name: response.data.bank_name,
          maturity_date: response.data.maturity_date,
        });

        setPIdocument(
          response.data.PI_document
            ? `${baseUrl}${response.data.PI_document}`
            : null
        );
        setLCdocument(
          response.data.LC_document
            ? `${baseUrl}${response.data.LC_document}`
            : null
        );
        setAcceptanceCopy(
          response.data.Acceptance_copy
            ? `${baseUrl}${response.data.Acceptance_copy}`
            : null
        );

        console.log('First Refinance details:', response.data);
        // You can now prefill the form with the data here if needed
      } catch (error) {
        console.error('Error fetching loan details:', error);
      }
    };

    fetchLoanDetails();
  }, []);

  // get all issue bank api
  useEffect(() => {
    const fetchBankList = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/account/bank-list/`,
          // 'https://finwise-backend.vercel.app/account/bank-list/',
          // 'https://finwiseback.finwise.com.bd/account/bank-list/',
          // 'http://127.0.0.1:8000/account/bank-list/',
          {
            headers: {
              Cookie:
                'csrftoken=YmXTCIwY0VzFyPEcOP15TL1stJiuNrZF; sessionid=l2509fh2uv9ulyzd6412afq0ufd2elpr',
            },
            withCredentials: true,
          }
        );

        // Assuming the response has a list of banks
        setBankList(response.data);
        // console.log(response);
      } catch (error) {
        console.error('Error fetching the bank list:', error);
      }
    };

    fetchBankList();
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();

    const upodateData = new FormData();
    upodateData.append('UPAS_bank_name', formData.UPAS_bank_name);
    upodateData.append('UPAS_maturity_date', formData.UPAS_maturity_date);
    upodateData.append('bank_name', formData.bank_name);
    upodateData.append('maturity_date', formData.maturity_date);

    if (fileInputRef.current && fileInputRef.current.files[0]) {
      upodateData.append('PI_document', null);
    }
    if (fileInputRef.current && fileInputRef.current.files[0]) {
      upodateData.append('LC_document', null);
    }
    if (fileInputRef.current && fileInputRef.current.files[0]) {
      upodateData.append('Acceptance_copy', null);
    }
    // if (fileInputRef.current && fileInputRef.current.files[0]) {
    //   upodateData.append('PI_document', fileInputRef.current.files[0]);
    // }
    // if (fileInputRef.current && fileInputRef.current.files[0]) {
    //   upodateData.append('LC_document', fileInputRef.current.files[0]);
    // }
    // if (fileInputRef.current && fileInputRef.current.files[0]) {
    //   upodateData.append('Acceptance_copy', fileInputRef.current.files[0]);
    // }

    // Log the formData to verify data being sent
    console.log('second refinance upodateData before submit:', upodateData);

    try {
      const response = await axios.put(
        // `http://127.0.0.1:8000/account/edit-apply-loan/12/`,
        // `https://finwise-backend.vercel.app/account/edit-apply-loan/${id}/`,
        // `https://finwiseback.finwise.com.bd/account/edit-apply-loan/${id}/`,
        `${API_BASE_URL}/account/edit-second-refinance-loan/${id}/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-CSRFToken': 'z91BDRm6OBq66qusVK8HCtvtdW686hFC',
            Cookie:
              'csrftoken=aNDEX8Hh9fBH9lwYAuuu2NoVREw0SYio; sessionid=b8tgjifnsbbwc1bpxwsqgqf1hnswfsml',
          },
          withCredentials: true,
        }
      );

      Swal.fire({
        title: 'Success!',
        text: 'Edit Your First Refinance Successful.',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });

      console.log('Loan Update response:', response.data);
      // Navigate to the dashboard or handle any further actions
      navigate('/dashboard');
    } catch (error) {
      if (error.response) {
        Swal.fire({
          title: 'Error!',
          text: 'Edit Your First Refinance Failed!',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            confirmButton:
              'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
          },
        });
        console.error('Server response error:', error.response.data);
      } else {
        console.error('Error submitting loan application:', error);
      }
    }
  };

  return (
    <>
      {isFormVisible && (
        <div className="md:px-10 px-2 md:py-10 py-6 ">
          {/* title header */}
          <div className="bg-headerBtn md:w-full p-2  md:pl-8 pl-4 text-left rounded-t-lg ">
            <div className="flex justify-between">
              <div>
                <h2 className="md:text-2xl text-lg text-white font-bold md:mb-2">
                  Edit Second Refinance Application
                </h2>
                <p className="md:mb-2 text-xs md:text-sm text-white">
                  Edit for your initial loan refinancing and manage your
                  financial commitments with ease.
                </p>
              </div>

              {/* Close button */}
              {/* <button
                onClick={handleCloseApplyLoan}
                className="md:mr-4 mr-3 -mt-6 text-white text-2xl font-bold hover:text-btnHover"
              >
                &times;
              </button> */}
            </div>
          </div>

          {/* form fields */}
          <div className="bg-AboutUsBg md:text-sm text-xs flex flex-col items-center md:py-10 py-4 px-4 md:px-0 xl:h-auto">
            <form
              onSubmit={handleSubmit}
              action=""
              className="w-full max-w-4xl"
            >
              {/* All form fields start from here */}
              <div className="md:space-y-2 space-y-2">
                {/* UPAS Bank Name * */}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1 ">
                  <div>
                    <label
                      htmlFor="UPAS_bank_name"
                      className="block font-medium text-gray-700"
                    >
                      UPAS Bank Name <span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="text-3xl hidden md:block ml-3">:</span>
                    </div>

                    <div className="">
                      <select
                        id="UPAS_bank_name"
                        value={formData.UPAS_bank_name}
                        onChange={handleInputChange}
                        className="md:w-96 w-64 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                        required
                      >
                        <option value="">Select Bank</option>
                        {bankList.map((bank, index) => (
                          <option key={index} value={bank[0.0]}>
                            {bank[0.0]}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* UPAS Maturity Date * */}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="UPAS_maturity_date"
                      className="block font-medium text-gray-700"
                    >
                      UPAS Maturity Date
                      <span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="hidden md:block text-3xl ml-1">:</span>
                    </div>

                    <div className="">
                      <input
                        type="date"
                        id="UPAS_maturity_date"
                        value={formData.UPAS_maturity_date}
                        onChange={handleInputChange}
                        className="md:w-96 w-64 p-2 border border-gray-300 rounded-md"
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* First Refinance Information */}
                <div className="pt-10 pb-4">
                  <h1 className="heading text-xl ">
                    First Refinance Information:
                  </h1>
                </div>
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1 ">
                  <div>
                    <label
                      htmlFor="bank_name"
                      className="block font-medium text-gray-700"
                    >
                      Bank Name <span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="text-3xl hidden md:block ml-14">:</span>
                    </div>

                    <div className="">
                      <select
                        id="bank_name"
                        value={formData.bank_name}
                        onChange={handleInputChange}
                        className="md:w-96 w-64  p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                        required
                      >
                        <option value="">Select Bank</option>
                        {bankList.map((bank, index) => (
                          <option key={index} value={bank[0.0]}>
                            {bank[0.0]}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* UPAS Maturity Date * */}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="maturity_date"
                      className="block font-medium text-gray-700"
                    >
                      Maturity Date
                      <span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="hidden md:block text-3xl ml-12">:</span>
                    </div>

                    <div className="">
                      <input
                        type="date"
                        id="maturity_date"
                        value={formData.maturity_date}
                        onChange={handleInputChange}
                        className="md:w-96 w-64  p-2 border border-gray-300 rounded-md"
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Documents Upload : */}
                <div className="pt-10 pb-4">
                  <h1 className="heading text-xl ">Documents Upload :</h1>
                </div>
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="PI_document"
                      className="block font-medium text-gray-700"
                    >
                      PI Copy <span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="hidden md:block text-3xl ml-20">:</span>
                    </div>

                    <div className="">
                      <input
                        type="file"
                        id="PI_document"
                        name="logo"
                        ref={fileInputRef}
                        // onChange={handleFileChange}
                        // onChange={e => handleFileChange(e, 'PI_document')}
                        className="md:w-96 w-64 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50 bg-white"
                      />
                      <div className="flex gap-2 items-center">
                        <p className="mt-1 text-sm text-gray-600">
                          <span className="font-semibold">
                            Your previous chosen file:
                          </span>{' '}
                          {/* {NidImage ? NidImage.name : 'No file chosen'} */}
                        </p>
                        {PIdocument && (
                          <img
                            src={
                              PIdocument instanceof File
                                ? URL.createObjectURL(PIdocument)
                                : PIdocument
                            }
                            alt="document"
                            className="rounded w-10 h-auto object-cover mt-2"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="LC_document"
                      className="block font-medium text-gray-700"
                    >
                      LC Copy<span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="hidden md:block text-3xl ml-20">:</span>
                    </div>

                    <div className="">
                      <input
                        type="file"
                        id="LC_document"
                        name="logo"
                        ref={fileInputRef}
                        // onChange={handleFileChange}
                        // onChange={e => handleFileChange(e, 'LC_document')}
                        className="md:w-96 w-64 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50 bg-white"
                      />
                      <div className="flex gap-2 items-center">
                        <p className="mt-1 text-sm text-gray-600">
                          <span className="font-semibold">
                            Your previous chosen file:
                          </span>{' '}
                          {/* {NidImage ? NidImage.name : 'No file chosen'} */}
                        </p>
                        {LCdocument && (
                          <img
                            src={
                              LCdocument instanceof File
                                ? URL.createObjectURL(LCdocument)
                                : LCdocument
                            }
                            alt="document"
                            className="rounded w-10 h-auto object-cover mt-2"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="Acceptance_copy"
                      className="block font-medium text-gray-700"
                    >
                      Acceptance Copy<span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="hidden md:block text-3xl ml-3">:</span>
                    </div>

                    <div className="">
                      <input
                        type="file"
                        id="Acceptance_copy"
                        name="logo"
                        ref={fileInputRef}
                        // onChange={handleFileChange}
                        // onChange={e => handleFileChange(e, 'Acceptance_copy')}
                        className="md:w-96 w-64 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50 bg-white"
                      />
                      <div className="flex gap-2 items-center">
                        <p className="mt-1 text-sm text-gray-600">
                          <span className="font-semibold">
                            Your previous chosen file:
                          </span>{' '}
                          {/* {NidImage ? NidImage.name : 'No file chosen'} */}
                        </p>
                        {AcceptanceCopy && (
                          <img
                            src={
                              AcceptanceCopy instanceof File
                                ? URL.createObjectURL(AcceptanceCopy)
                                : AcceptanceCopy
                            }
                            alt="document"
                            className="rounded w-10 h-auto object-cover mt-2"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* All form fields end */}

              {/* Apply and cancel Buttons  */}
              <div className="flex md:w-full w-2/3 justify-center space-x-4 mt-6 ">
                <button
                  // onClick={handleSubmit}
                  type="submit"
                  className="bg-headerBtn text-white md:py-2 py-1 md:px-6 px-2 text-xs md:text-sm rounded-lg hover:bg-btnHover"
                >
                  Apply Now
                </button>
                <button
                  onClick={handleCloseApplyLoan}
                  type="button"
                  className="border-headerBtn border-2 text-headerBtn text-xs md:text-sm md:py-2 py-1 md:px-6 px-2 rounded-lg hover:bg-btnHover hover:text-white"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default EditSecondRefinancePage;
